import { Box } from "@mui/material";
import { ReactNode } from "react";

/** Narrowest a stat card may get before the grid drops a column. Sized so a
 * card's caption ("Shipments differing from manifest") wraps to two lines
 * rather than breaking mid-word. */
const DEFAULT_MIN_WIDTH = "11.5rem";

/**
 * Auto-fitting grid of equal-width stat boxes.
 *
 * Replaces the wrapping flex row the waste tiles used to lay these out. Once
 * the tiles became half-width, a flex row left the last card on its own line
 * stretched to full width; `auto-fit` keeps every card in a column of equal
 * width and drops columns as the container narrows.
 */
export function StatCardGrid({
  children,
  minWidth = DEFAULT_MIN_WIDTH,
  testId,
}: {
  children: ReactNode;
  /** Override for rows of boxes that need more or less room than a stat card —
   * a five-across count row wants less, a field holding a street address more. */
  minWidth?: string;
  /** Names this row so a test can scope to it. Stat labels are short enough
   * ("Satellite", "Central") to collide with copy elsewhere on the page. */
  testId?: string;
}) {
  return (
    <Box
      data-testid={testId}
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(auto-fit, minmax(${minWidth}, 1fr))`,
        gap: 2,
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
}
